import { useRowSelect } from '@table-library/react-table-library/select';
import { Action, State } from '@table-library/react-table-library/types/common';
import { Button, TableItem } from 'components/atoms';
import { LabeledStatus } from 'components/molecules';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetSalesChannelsInfiniteList } from 'services/salesChannel';
import {
  DISTRIBUTION_FORM,
  ISalesChannelResponse,
} from 'services/salesChannel/types';
import { ACTIVE_STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getNodes } from 'utils/table/nodes.utils';
import { usePermissionGuard } from 'hooks/usePermissionGuard';
import { useHasPermission } from 'hooks';
enum SALES_COLUMNS {
  name,
  distribution,
  isActive,
}

const SaleChannels = () => {
  usePermissionGuard('SalesChannelPermissionsLIST**');

  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasPermission = useHasPermission();

  const { data, isLoading, fetchNextPage, isFetchingNextPage } =
    useGetSalesChannelsInfiniteList({});
  const columnsVisibility = useTableColumnsVisibility(
    'SaleChannels1',
    SALES_COLUMNS
  );

  const tableData = getNodes<ISalesChannelResponse>(data?.pages.flat());

  const onSelectChange = (action: Action, state: State) => {
    if (!hasDetailPermission) {
      return;
    }
    
    navigate(`/settings/sales-channel/${action.payload.id}/providers`);
  };

  const select = useRowSelect(tableData, {
    onChange: onSelectChange,
  });

  const hasDetailPermission = hasPermission('SalesChannelPermissionsLIST**', 512);
  const tableSelect = hasDetailPermission ? select : undefined;

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t(`sales-channel.list.title`)}
          hideBackButton
          topbarContent={
            <>
              {/* <Table.CustomColumnsButton
                columns={SALES_COLUMNS}
                isClear
                visibility={columnsVisibility}
                i18nextPrefix='input.label'
                customI18next=''
              /> */}
              {hasPermission('SalesChannelPermissionsLIST**', 32) && (
                <Button
                  variant={BUTTON_VARIANT.submit}
                  onClick={() => navigate(`/settings/sales-channel/create/`)}>
                  <Button.Text
                  text={t(`button.create-what`, {
                    what: t('sales-channel.what'),
                    })}
                  />
                </Button>
              )}
            </>
          }
        />
      }>
      <Table
        id={columnsVisibility.tableId}
        select={tableSelect}
        loading={isLoading || isFetchingNextPage}
        onFullyScroll={fetchNextPage}
        data={tableData}
        columns={[
          {
            label: t('input.label.name'),
            renderCell: item => (
              <TableItem>
                <div className='flex flex-row items-center gap-4'>
                  <TableItem.Image url={item.logoImageUrl} alt={item.name} />
                  <TableItem.Text text={item.name} />
                </div>
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SALES_COLUMNS.name),
          },
          {
            label: t('input.label.distribution'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text
                  text={t(`${DISTRIBUTION_FORM[item.distributionForm]}`)}
                />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SALES_COLUMNS.distribution),
          },

          {
            label: t('input.label.isActive'),
            renderCell: item => (
              <TableItem>
                <LabeledStatus.Active
                  status={
                    item.isActive
                      ? ACTIVE_STATUS.Active
                      : ACTIVE_STATUS.Inactive
                  }
                />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SALES_COLUMNS.isActive),
          },
        ]}
        displayMode
      />
    </TopbarPage>
  );
};

export default SaleChannels;
